/** Trigger a browser download of in-memory content — no server round
 *  trip. Identical pattern to tengrade's web-examiner/src/lib/download.ts. */
export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
